const resources = {
  ru: {
    translation: {
      app: {
        title: 'Игры с голосом',
        description: 'Приложение с изображениями для детей',
      },
      kids: {
        ui: {
          selectStory: 'Выбор истории',
          close: 'Закрыть',
          placeholder: 'Скоро',
          loading: 'Загрузка…',
          languageRu: 'RU',
          languageEn: 'EN',
          fullscreen: 'На весь экран',
          tuneAudio: 'Тайминги аудио',
          rotateTitle: 'Поверните телефон',
          rotateHint: 'Для игры нужен горизонтальный режим (landscape).',
        },
        tuner: {
          filter: 'Фильтр',
          filterPlaceholder: 'cueId или слово из текста…',
          title: 'Тайминг аудио (мин:сек)',
          copyJson: 'Copy JSON cues',
          tableAria: 'Таблица таймингов аудио',
          cueId: 'Cue ID',
          text: 'Текст',
          start: 'Старт',
          nudge: 'Сдвиг (ms)',
          play: 'Play',
          playSelected: 'Play selected',
          stop: 'Stop',
          select: 'Выбрать',
          lang: 'Язык',
          cuesCount: 'Кусочков',
          lastCue: 'Последний старт',
          noSprite: 'Аудио-спрайт не подключён для этого языка.',
          normalizeZero: 'Нормализовать: старт = 00:00.000',
          reset: 'Сброс',
          shiftAfter: 'Сдвиг после выбранного (ms)',
          shiftAll: 'Сдвиг всех (ms)',
          applyMs: 'Применить',
          hintLine1: 'Правь время в формате 00:12.345 и жми Enter (или просто выйди из поля).',
          hintLine2: 'Кнопка Copy JSON cues — копирует массив cues в буфер (можно вставить в story.json).',
        },
        editor: {
          copyZones: 'Копировать зоны',
          copyScene: 'Копировать сцену',
          hint: 'Режим правки: перетаскивай/ресайзь рамки. Координаты 0..1.',
        },
        stories: {
          story001: {
            title: 'Техника',
            scene001: {
              crane: 'Кран поднимает тяжёлые грузы.',
              hook: 'Это крюк. Им цепляют груз.',
              slab: 'Бетонная плита.',
              bricks: 'Кирпичи. Из них строят стены.',
              wheelbarrow: 'Тачка. В ней возят песок и землю.',
            },
            scene002: {
              cement_truck: 'Бетономешалка везёт бетон на стройку.',
              chute: 'По лотку бетон течёт вниз.',
              concrete: 'Мокрый бетон. Он потом станет твёрдым.',
              cement_bags: 'Мешки с цементом.',
              bricks: 'Кирпичи. Из них строят стены.',
            },
            scene003: {
              tanker_truck: 'Топливный грузовик привёз бензин на заправку.',
              fuel_pumps: 'Это колонки. Через них наливают топливо в машину.',
              station_canopy: 'Навес на заправке. Он укрывает от дождя и солнца.',
              underground_tank: 'Подземный бак. В нём хранится топливо.',
              pickup_truck: 'Пикап. Лёгкий грузовик с открытым кузовом.',
            },
            scene004: {
              dump_truck: 'Самосвал привёз песок на стройку.',
              dump_bed: 'Кузов самосвала поднимается, чтобы высыпать груз.',
              crane: 'Кран на стройке помогает поднимать материалы.',
              wheelbarrow: 'Тачка. В ней возят песок и землю.',
              worker: 'Строитель следит за работой на площадке.',
            },
            scene005: {
              bulldozer: 'Бульдозер толкает землю и разравнивает площадку.',
              bulldozer_blade: 'Отвал — большая лопата спереди. Ею толкают грунт.',
              tracks: 'Гусеницы помогают ехать по песку и грязи, не проваливаясь.',
              lighthouse: 'Маяк. Он помогает кораблям находить берег.',
              ship: 'Корабль везёт груз по морю.',
            },
            scene006: {
              excavator_crane: 'Экскаватор с крановой стрелой поднимает тяжёлый груз.',
              hook: 'Крюк держит груз на тросах.',
              bricks: 'Кирпичи на поддоне. Их поднимают краном.',
              lighthouse: 'Маяк. Он помогает кораблям находить берег.',
              ship: 'Корабль плывёт по морю.',
            },
            scene007: {
              police_van: 'Полицейский фургон помогает перевозить оборудование и людей.',
              officer: 'Полицейский держит рацию и сообщает новости.',
              driver: 'Водитель ведёт машину и следит за дорогой.',
              lightbar: 'Проблесковые маячки мигают, чтобы все заметили полицию.',
              equipment: 'Внутри лежит оборудование: рации и аптечка.',
            },
            scene008: {
              ambulance: 'Скорая помощь спешит к людям, чтобы помочь.',
              paramedic: 'Фельдшер несёт аптечку и готов помочь пациенту.',
              driver: 'Водитель скорой ведёт машину и спешит на вызов.',
              stretcher: 'Каталка нужна, чтобы аккуратно перевозить пациента.',
              lightbar: 'Маячки на крыше мигают и предупреждают других водителей.',
            },
            scene009: {
              fire_truck: 'Пожарная машина привезла пожарных и оборудование.',
              ladder: 'Лестница помогает подняться высоко и спасать людей.',
              firefighter: 'Пожарный тушит огонь водой из шланга.',
              hose: 'Шланг подаёт воду к месту пожара.',
              fire: 'Огонь опасный. Его нужно быстро потушить.',
            },
            scene010: {
              garbage_truck: 'Мусоровоз собирает мусор, чтобы в городе было чисто.',
            },
            scene011: {
              excavator: 'Экскаватор копает землю на строительной площадке.',
              excavator_bucket: 'Ковш экскаватора роет грунт и поднимает его.',
              operator: 'Оператор управляет экскаватором из кабины.',
              construction_tower_crane: 'Строительный кран поднимает тяжелые материалы.',
            },
            scene012: {
              wheel_loader: 'Погрузчик на колесах перемещает грунт и материалы.',
              loader_bucket: 'Ковш погрузчика захватывает грунт и загружает его.',
              loader_operator: 'Оператор управляет погрузчиком со своего места.',
              soil_pile: 'Кучи грунта ждут своей очереди на погрузку.',
            },
            scene013: {
              tractor: 'Трактор работает в поле или на стройке.',
              tractor_loader: 'Фронтальный погрузчик трактора поднимает материалы.',
              tractor_operator: 'Фермер управляет трактором из кабины.',
              hay: 'Сено готово к перевозке или хранению.',
            },
          },
          story002: { title: 'История 2' },
        },
        elements: {
          house: 'Дом',
          sun: 'Солнце',
          chicken: 'Курица',
          tree: 'Дерево',
          fence: 'Забор',
          flowers: 'Цветы',
        },
      },
    },
  },
  en: {
    translation: {
      app: {
        title: 'Voice Games',
        description: 'App with images for kids',
      },
      kids: {
        ui: {
          selectStory: 'Choose a story',
          close: 'Close',
          placeholder: 'Soon',
          loading: 'Loading…',
          languageRu: 'RU',
          languageEn: 'EN',
          fullscreen: 'Fullscreen',
          tuneAudio: 'Audio timings',
          rotateTitle: 'Rotate your phone',
          rotateHint: 'This game works best in landscape mode.',
        },
        tuner: {
          filter: 'Filter',
          filterPlaceholder: 'cueId or text…',
          title: 'Audio timing (mm:ss)',
          copyJson: 'Copy JSON cues',
          tableAria: 'Audio timings table',
          cueId: 'Cue ID',
          text: 'Text',
          start: 'Start',
          nudge: 'Nudge (ms)',
          play: 'Play',
          playSelected: 'Play selected',
          stop: 'Stop',
          select: 'Select',
          lang: 'Lang',
          cuesCount: 'Cues',
          lastCue: 'Last start',
          noSprite: 'Audio sprite is not configured for this language.',
          normalizeZero: 'Normalize: start = 00:00.000',
          reset: 'Reset',
          shiftAfter: 'Shift after selected (ms)',
          shiftAll: 'Shift all (ms)',
          applyMs: 'Apply',
          hintLine1: 'Edit time as 00:12.345 and press Enter (or just blur the field).',
          hintLine2: 'Copy JSON cues copies the cues array to clipboard (paste into story.json).',
        },
        editor: {
          copyZones: 'Copy zones',
          copyScene: 'Copy scene',
          hint: 'Edit mode: drag/resize boxes. Coordinates are 0..1.',
        },
        stories: {
          story001: {
            title: 'Story 1',
            scene001: {
              crane: 'A crane lifts heavy loads.',
              hook: "It's a hook. It grabs the load.",
              slab: 'A concrete slab.',
              bricks: 'Bricks. They are used to build walls.',
              wheelbarrow: 'A wheelbarrow. It carries sand and soil.',
            },
            scene002: {
              cement_truck: 'A cement mixer truck brings concrete to the site.',
              chute: 'Concrete flows down the chute.',
              concrete: 'Wet concrete. It will become hard later.',
              cement_bags: 'Bags of cement.',
              bricks: 'Bricks. They are used to build walls.',
            },
            scene003: {
              tanker_truck: 'A fuel tanker truck brought gasoline to the station.',
              fuel_pumps: 'These are pumps. They fill a car with fuel.',
              station_canopy: 'The gas station canopy. It protects from sun and rain.',
              underground_tank: 'An underground tank. Fuel is stored inside.',
              pickup_truck: 'A pickup truck. It has an open cargo bed.',
            },
            scene004: {
              dump_truck: 'A dump truck brought sand to the construction site.',
              dump_bed: 'The dump bed lifts up to unload the sand.',
              crane: 'A crane helps lift materials on the site.',
              wheelbarrow: 'A wheelbarrow. It carries sand and soil.',
              worker: 'A construction worker watches over the work area.',
            },
            scene005: {
              bulldozer: 'A bulldozer pushes soil and levels the ground.',
              bulldozer_blade: 'The blade is a big front shovel. It pushes dirt forward.',
              tracks: 'Tracks help it move on sand and mud without sinking.',
              lighthouse: 'A lighthouse. It helps ships find the shore.',
              ship: 'A ship carries cargo across the sea.',
            },
            scene006: {
              excavator_crane: 'An excavator crane lifts a heavy load.',
              hook: 'The hook holds the load with cables.',
              bricks: 'Bricks on a pallet. A crane can lift them.',
              lighthouse: 'A lighthouse. It helps ships find the shore.',
              ship: 'A ship sails on the sea.',
            },
            scene007: {
              police_van: 'A police van carries equipment and people.',
              officer: 'A police officer holds a radio and shares updates.',
              driver: 'The driver steers the vehicle and watches the road.',
              lightbar: 'The lightbar flashes so everyone can see the police.',
              equipment: 'Inside there is gear: radios and a first-aid kit.',
            },
            scene008: {
              ambulance: 'An ambulance rushes to help people.',
              paramedic: 'A paramedic carries a first-aid kit and is ready to help.',
              driver: 'The ambulance driver steers and hurries to the call.',
              stretcher: 'A stretcher helps move a patient safely.',
              lightbar: 'The roof lights flash to warn other drivers.',
            },
            scene009: {
              fire_truck: 'A fire truck brought firefighters and equipment.',
              ladder: 'A ladder helps reach high places to rescue people.',
              firefighter: 'A firefighter sprays water to put out the fire.',
              hose: 'A hose brings water to the fire.',
              fire: 'Fire is dangerous. It must be put out quickly.',
            },
            scene010: {
              garbage_truck: 'The garbage truck picks up trash to keep the city clean.',
            },
            scene011: {
              excavator: 'An excavator digs soil at the construction site.',
              excavator_bucket: "The excavator's bucket scoops and lifts dirt.",
              operator: 'The operator controls the excavator from the cabin.',
              construction_tower_crane: 'A construction crane lifts heavy materials.',
            },
            scene012: {
              wheel_loader: 'A wheel loader moves soil and materials around.',
              loader_bucket: "The loader's bucket grabs soil and loads it.",
              loader_operator: 'The operator controls the loader from the seat.',
              soil_pile: 'Piles of soil wait to be loaded.',
            },
            scene013: {
              tractor: 'A tractor works in the field or at construction.',
              tractor_loader: "The tractor's front loader lifts materials.",
              tractor_operator: 'A farmer controls the tractor from the cabin.',
              hay: 'Hay is ready to be transported or stored.',
            },
          },
          story002: { title: 'Story 2' },
        },
        elements: {
          house: 'House',
          sun: 'Sun',
          chicken: 'Chicken',
          tree: 'Tree',
          fence: 'Fence',
          flowers: 'Flowers',
        },
      },
    },
  },
};

export default resources;